<template>
  <div class="svg-body">
    <div id="svgEmbed"></div>
  </div>
</template>
<script>
import $ from 'jquery';
import svgPanZoom from '../utils/svg-pan-zoom';

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    svgHtml: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mutableVal: this.value,
      seatSelector: null,
      seatBoxSelector: null
    };
  },
  methods: {
    getSvg(cb) {
      $.get(
        this.svgHtml,
        { Origin: 'jn-v2' },
        (svg) => {
          $('#svgEmbed').html(svg);
          cb();
        },
        'text'
      );
    },
    init(cb) {
      this.getSvg(() => {
        this.seatSelector = $('.svg-seat');
        this.seatBoxSelector = $('.svg-block-seats');
        this.disableAllSeats();
        svgPanZoom('#svgZoom');
        this.clickSeat();
        this.clickBlockSeat();
        cb();
      });
    },
    clickSeat() {
      this.seatSelector.unbind('click');
      this.seatSelector.on('click', (event) => {
        event.stopPropagation();
        const {
          id,
          dataset: { disabled, toggle }
        } = event.currentTarget;
        if (disabled) return;
        if (!toggle) {
          this.$emit('on-verify-seat', { id });
        } else {
          this.updateSeat(id);
        }
      });
    },
    clickBlockSeat() {
      this.seatBoxSelector.unbind('click');
      this.seatBoxSelector.on('click', (event) => {
        event.stopPropagation();
        const {
          id,
          dataset: { disabled, toggle }
        } = event.currentTarget;
        if (disabled) return;
        const seats = $(`#${id} .svg-seat`);
        const arrSeat = [];
        $.each(seats, (i, item) => {
          arrSeat.push(item.id);
        });
        seats.trigger('click');
        if (toggle) {
          this.$emit('on-box-seats', []);
          $(`#${id}`).removeAttr('data-toggle');
        } else {
          this.$emit('on-box-seats', arrSeat);
        }
      });
    },
    updateSeat(id) {
      const seat = Object.assign(this.mutableVal[id]);
      this.$delete(this.mutableVal, id);
      $(`#${id}`).removeAttr('data-toggle');
      // this.$emit('on-verify-seat', this.mutableVal[id], true);
      this.$emit('update-seat', { isRemove: true, type: seat.type, id });
      this.$emit('input', this.mutableVal);
    },
    setSeatVerify(available, { type, id }) {
      // available: 0, 1 | false, true
      if (available) {
        this.$set(this.mutableVal, id, { type, id });
        $(`#${id}`).attr('data-toggle', true).removeAttr('data-disabled');
        $(`#${id}`).parent('.svg-block-seats').attr('data-toggle', true);
        this.$emit('update-seat', { isRemove: false, type, id });
      } else {
        this.disableSeats([id]);
        // eslint-disable-next-line
        alert('Este asiento ya no está disponible!');
      }
      this.$emit('input', this.mutableVal);
    },
    disableAllSeats() {
      this.seatSelector.attr('data-disabled', true).removeAttr('data-toggle');
      this.seatBoxSelector.attr('data-disabled', true).removeAttr('data-toggle');
      // this.mutableVal = {}
      // this.$emit('input', this.mutableVal)
    },
    enableSeats(seatsArr) {
      seatsArr.forEach((item) => {
        if (typeof item.id !== 'undefined' && item.id !== '') {
          const seatId = item.id.toUpperCase();
          $(`#${seatId}`).removeAttr('data-disabled').removeAttr('data-toggle');
          $(`#${seatId}`)
            .parent('.svg-block-seats')
            .removeAttr('data-disabled')
            .removeAttr('data-toggle');
        }
      });
    },
    disableSeats(seatsArr) {
      seatsArr.forEach((id) => {
        if (typeof id !== 'undefined' && id !== '') {
          const seat = id.toUpperCase();
          $(`#${seat}`).attr('data-disabled', true);
          $(`#${seat}`).parent('.svg-block-seats').attr('data-disabled', true);
        }
      });
    },
    selectToggleSeats(seatsArr) {
      seatsArr.forEach((item) => {
        if (typeof item.id !== 'undefined' && item.id !== '') {
          this.setSeatVerify(true, item);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.svg-body {
  height: 65vh;
  padding: 0;
  background: #fff;
  box-shadow: inset 0 5px 10px rgba(#000, 0.2);

  svg {
    width: 100%;
    height: 64vh;
  }
}

.svg-block-seats,
.svg-seat {
  cursor: pointer;

  circle,
  path,
  rect {
    fill: #00e5b5;
  }

  text {
    fill: #031425;
  }

  &[data-disabled] {
    cursor: default;
  }

  &[data-disabled] path,
  &[data-disabled] circle,
  &[data-disabled] rect {
    fill: #bbb;
  }

  &[data-toggle] {
    
    circle,
    path,
    rect {
      fill: #f95353;
    }

    text {
      fill: #fff;
    }
  }
}
</style>
